// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"23674":"b0d1a22836d82be75e1d","60685":"2cddeb57abd937455f4a"}[chunkId] + ".css";
};